<footer class="footer">
  <div class="footer__content">
    <!-- Логотип -->
    <div class="footer__logo">
      <img title="JECRM" src="assets/img/jecrm.png" alt="JECRM" />
      <div class="footer__slogan">{{ 'digital_business_transformation' | translate }}</div>
    </div>

    <!-- Центр -->
    <div class="footer__center">
      <div>© JECRM by Jestos</div>
      <div>+38 098 575 98 51</div>
      <div class="media">
        <div *ngFor="let media of medias" (click)="baseService.openSite(media.link)">
          <img [src]="media.icon" alt="media icon" class="menu-icon rounded-circle" />
        </div>
      </div>
    </div>

    <!-- Посилання та платежі -->
    <div class="footer__links">
      <a title="terms-of-use" href="/terms-of-use">{{ 'terms_of_use' | translate }}</a>
      <a title="privacy-policy" href="/privacy-policy">{{ 'privacy_policy' | translate }}</a>
      <div class="footer__payments">
        <img title="liqpay" src="assets/img/liqpay.svg" alt="liqpay" />
        <img title="visa" src="assets/img/visa.svg" alt="visa" />
        <img title="mastercard" src="assets/img/mastercard.svg" alt="mastercard" />
      </div>
    </div>
  </div>

</footer>
